import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Spinner from 'components/Spinner/desktop';

import { checkBonusPromoAllowed } from 'features/bonusProgram/data';

import GiftEditor from './GiftEditor';
import CurrentGifts from './CurrentGifts';
import './GiftManagement.scss';

const b = block('gift-management-desktop');

const GiftManagement = () => {
  const actionProcessing = useSelector(s => s.bonusProgram.actionProcessing);
  const authData = useSelector(s => s.auth);
  if (!checkBonusPromoAllowed(authData)) return null;

  return (
    <article className={b()}>
      <Spinner isLoading={actionProcessing} />
      <GiftEditor />
      <CurrentGifts />
    </article>
  );
};

export default GiftManagement;
